/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { useCommitMutation } from '@@views/_common/client/hooks/useCommitMutation';
import DownloadDocumentsSub4Mutation from '../graphql/mutations/DownloadDocumentsSub4Mutation.js';

export const useDownloadDocumentsSub4Mutation = () => {
  return useCommitMutation(DownloadDocumentsSub4Mutation, {
    dataProp: 'downloadDocumentsSub4_M_souscription_recap'
  });
};

export default useDownloadDocumentsSub4Mutation;
